/** Hairline rule with a centred label — "Of oefen losse delen / taken". */
export function Divider({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-3.5 text-[13px] text-[var(--ink-faint)] py-1">
      <span className="h-px flex-1 bg-[var(--border)]" aria-hidden />
      <span>{label}</span>
      <span className="h-px flex-1 bg-[var(--border)]" aria-hidden />
    </div>
  );
}
